const AndroidRegexp = /Android/i;
const IosRegexp = /iPhone/i;
const MobileRegexp = /iPhone|Android/i;

export function isAndroid(): boolean {
    return AndroidRegexp.test(navigator.userAgent);
}

export function isIos(): boolean {
    return IosRegexp.test(navigator.userAgent);
}

export function isMobile(): boolean {
    return MobileRegexp.test(navigator.userAgent);
}
